import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { customFieldValues } from "../custom_fields";

// Bodega/almacen. Pertenece SIEMPRE a una sucursal (branchId); una sucursal
// puede tener varias. isDefault marca la bodega por defecto de la sucursal.
export const validatorWarehouse = v.object({
  name: v.string(),
  code: v.optional(v.string()),
  branchId: v.id("branches"),
  address: v.optional(v.string()),
  isDefault: v.optional(v.boolean()),
  isActive: v.boolean(),
  internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});

export const warehouses = defineTable(validatorWarehouse)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch", ["branchId"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_state", ["internalControl.state"])
  .index("by_created_at", ["internalControl.createdAt"]);
